module.exports = __webpack_public_path__ + "media/logos/press-logo-attorneys-c5445ca4.png";